import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { Tracking } from '@app/services/tracking/tracking.service';
import { PortalTrackingEvents } from '@app/utils/tracking-events';

@Component({
  selector: 'quote-thank-you-page',
  templateUrl: './quote-thank-you-page.component.html',
  styleUrls: ['./quote-thank-you-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuoteThankYouPageComponent implements OnInit {
  ngOnInit() {
    Tracking.track(PortalTrackingEvents.portalAutoQuoteThankYouPageOpened);
  }
}
